import React, {useEffect, useRef, memo} from 'react'
import {decode} from 'blurhash'

export type Props = React.CanvasHTMLAttributes<HTMLCanvasElement> & {
    hash: string
    height?: number
    punch?: number
    width?: number
}

const BlurhashCanvas = memo(({hash, height = 128, width = 128, punch, ...rest}: Props) => {
    const canvasRef = useRef<HTMLCanvasElement | null>(null)

    const draw = () => {
        if (!hash || hash.length < 6) return
        if (!canvasRef.current) return

        const pixels = decode(hash, width, height, punch)
        const ctx = canvasRef.current.getContext('2d')
        if (!ctx) return

        const imageData = ctx.createImageData(width, height)
        imageData.data.set(pixels)
        ctx.putImageData(imageData, 0, 0)
    }

    useEffect(() => {
        draw()
    }, [hash, height, width, punch])
    if (!hash || hash.length < 6) {
        return <canvas {...rest} height={height} width={width} ref={canvasRef} />
    }
    return <canvas {...rest} height={height} width={width} ref={canvasRef} />
})

BlurhashCanvas.displayName = 'BlurhashCanvas'

export default BlurhashCanvas
